import ReactDOM from 'react-dom'
// import * as Sentry from '@sentry/browser'
// import ReactGA from 'react-ga'
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { App } from './app/App.controller'
import reportWebVitals from './reportWebVitals'
import { unregister } from './serviceWorker'
import { GlobalStyle } from './styles'

import './styles/fonts.css'

// Sentry.init({ dsn: 'XXX' })
// ReactGA.initialize('XXX')

export const Root = () => {
  return (
    <>
      {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} language="en"> */}
      <GlobalStyle />
      <App />
      {/* </GoogleReCaptchaProvider> */}
    </>
  )
}

const rootElement = document.getElementById('root')
ReactDOM.render(<Root />, rootElement)

unregister()
reportWebVitals()
